import { useEffect } from 'react'

export default function BaseDashboard() {
  useEffect(() => {
    // 直接跳转到合作伙伴工作台（不使用hash）
    window.location.href = '/cms/?page=partner-store'
  }, [])
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      background: '#f5f5f5'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🔄</div>
        <p style={{ color: '#666' }}>正在跳转到合作伙伴工作台...</p>
      </div>
    </div>
  )
}
